// Configuração central do WhatsApp Eco Collection — um único número para todo o site.
// Definir REACT_APP_WHATSAPP_NUMBER em frontend/.env (formato internacional sem '+', ex: 2399900000).
const NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '';

export const waConfigured = Boolean(NUMBER);

export const waLink = (message) =>
  waConfigured ? `https://wa.me/${NUMBER}?text=${encodeURIComponent(message)}` : '#whatsapp-not-configured';
